import { render, staticRenderFns } from "./AddAccount.vue?vue&type=template&id=42249711&scoped=true&"
import script from "./AddAccount.vue?vue&type=script&lang=js&"
export * from "./AddAccount.vue?vue&type=script&lang=js&"
import style0 from "./AddAccount.vue?vue&type=style&index=0&id=42249711&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42249711",
  null
  
)

export default component.exports